import {Box, Collapse} from "@mantine/core";
import cx from "clsx";
import classes from "./SubjectRow.module.css";
import commonClasses from "../../../../common/common.module.css";
import {
    IconChevronDown,
    IconChevronRight
} from "@tabler/icons-react";
import {useState} from "react";
import {
    dayjsToMonthDay,
} from "../../../../common/utils/times";
import {DashboardColors, DashboardIcons} from "../../common/constants";
import {IProtocolStats} from "../../types/IProtocolStats";
import {SessionRow} from "./SessionRow";


export interface SubjectRowProps {
    sStats: Array<IProtocolStats>
}

export const SubjectRow: React.FC<SubjectRowProps> = ({sStats}: SubjectRowProps) => {
    const [subjectsOpened, setSubjectsOpened] = useState(false)
    const gStats: IProtocolStats = sStats.reduce((agg, stats, i) => {
        // first one is our initial agg value
        if (i === 0)
            return agg
        agg.stimCount += stats.stimCount
        agg.megScanCount += stats.megScanCount
        agg.eegScanCount += stats.eegScanCount
        agg.ecgScanCount += stats.ecgScanCount
        agg.totalStimSeconds += stats.totalStimSeconds
        agg.totalMEGSeconds += stats.totalMEGSeconds
        agg.totalEEGSeconds += stats.totalEEGSeconds
        if (agg.startTime.isBefore(stats.startTime)) {
            agg.startTime = stats.startTime
        }
        return agg
    }, {...sStats[0]})

    const renderSessions = () => {
        return sStats.map((stats) => {
            return ( <SessionRow key={`sr-${stats.id}`} stats={stats} showSubject={false}/>)
        })

    }

    return (
        <Box key={gStats.id} p={"0.25em"} className={cx(classes.subjectRowContainer)}>
            <Box className={cx(classes.subjectRow, commonClasses.hover, commonClasses.sbRadius)}
                 onClick={() => setSubjectsOpened(!subjectsOpened)}>
                <Box>
                    {subjectsOpened ? <IconChevronDown size={"1em"}/> : <IconChevronRight size={"1em"}/>}
                </Box>
                <Box bg={"var(--bios-medium-blue)"} c={"var(--bios-dark-text)"} p={"0.5em"} style={{borderRadius: "0.5em"}}>
                    <DashboardIcons.subjectIcon size={"1em"}/>
                </Box>
                <Box fw="bold">{sStats[0].subjectName}</Box>
                <Box className={cx(classes.stats)}>
                    <Box>
                        <Box className={cx(classes.stat)} c={DashboardColors.sessions} fw={"bolder"}>
                            <DashboardIcons.sessionsIcon size={"1em"}/>
                            {sStats.length}
                        </Box>
                        <Box className={cx(classes.statText)}>Sessions</Box>
                    </Box>
                    <Box>
                        <Box className={cx(classes.stat)} c={"cyan.3"} fw={"bolder"}>
                            <DashboardIcons.stimulationsIcon size={"1em"}/>
                            {gStats.stimCount}
                        </Box>
                        <Box className={cx(classes.statText)}>Stimulations</Box>
                    </Box>
                    <Box>
                        <Box className={cx(classes.stat)} c={"pink.3"} fw={"bolder"}>
                            <DashboardIcons.megScanIcon size={"1em"}/> {gStats.megScanCount}
                        </Box>
                        <Box className={cx(classes.statText)}>MEG Scans</Box>
                    </Box>
                    <Box>
                        <Box className={cx(classes.statText)}>
                            Last Session
                        </Box>
                        <Box className={cx(classes.stat)} >
                            <Box style={{gridColumnStart: 0, gridColumnEnd: "span 2", justifySelf:"center"}}>
                                {dayjsToMonthDay(gStats.startTime)}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Collapse in={subjectsOpened}>
                <Box className={cx(classes.ehHeader, "ntc-row-component")}>
                    <DashboardIcons.fileTextIcon mr={"0.5em"}/> Session History ({sStats.length} Sessions)
                </Box>
                <Box mt={"1em"}>
                    {renderSessions()}
                </Box>
            </Collapse>
        </Box>
    )
}